import { useFlags } from 'featureFlags/helpers/useFlags';
import { useJobsitePulse } from 'containers/jobsite/tabs/jobsitePulse/components/JobsitePulseProvider';
import { DEMO_DRONE_CAMERA } from './droneDemoData';
import { DroneCamera } from './types';

/**
 * Returns the demo drone cameras to append to the camera list.
 * Only returns them when the feature flag is on and real cameras are loaded.
 */
export function useDroneCamerasList(): DroneCamera[] {
  const { cameras } = useJobsitePulse();
  const { showDroneDemo } = useFlags();

  if (!showDroneDemo || !cameras?.length) return [];
  return [DEMO_DRONE_CAMERA];
}
